export default "__VITE_ASSET__Bzd4coZv__"